// extracted by mini-css-extract-plugin
export default {"extraChartPreferences":"PreferencesFormComponent_extraChartPreferences__d8l4B","title":"PreferencesFormComponent_title__nBUjO"};